var _style, _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".american-express_svg__st2,.american-express_svg__st3{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}.american-express_svg__st3{fill:#296bb4}")), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20z",
    style: {
      fill: "#1e6cb3"
    },
    id: "american-express_svg__Calque_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "american-express_svg__Calque_3"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "american-express_svg__SVGID_1_",
    d: "M20 40C9 40 0 31 0 20S9 0 20 0s20 9 20 20-9 20-20 20z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "american-express_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#american-express_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#american-express_svg__SVGID_2_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "M14.4 33.7V19.2h25.8v4l-3 3.2 3 3.2v4.1h-4.7l-2.6-2.8-2.5 2.8h-16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st3",
    d: "M16.1 32.1V20.8h9.6v2.6h-6.5v1.7h6.4v2.6h-6.4v1.7h6.5v2.7h-9.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st3",
    d: "m25.7 32.1 5.3-5.7-5.3-5.6h4.1l3.2 3.5 3.3-3.5h3.9L35 26.4l5.2 5.5v.2h-4l-3.3-3.6-3.2 3.6h-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st2",
    d: "M15.6 6.3h6.2l2.2 4.9V6.3h7.7L33 10l1.4-3.7h5.8v14.5h-31l6.4-14.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "american-express_svg__st3",
    d: "m16.8 7.9-5 11.3h3.4l.9-2.3h5.1l.9 2.3h3.5l-5-11.3h-3.8zm.4 6.5 1.5-3.6 1.5 3.6h-3zM25.7 19.2V7.9h4.9l2.5 6.9 2.5-6.9h4.6v11.3h-3v-7.8l-2.8 7.8h-2.7l-2.9-7.8v7.8h-3.1z"
  })))));
};
export default SvgAmericanExpress;